import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";

export function NodeDelete({ openDelete, closeDelete, infoDelete, submitDelete }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { white, dark } = colors;

  return (
    <Dialog
      open={openDelete}
      onClose={closeDelete}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        textAlign: "center",
        "& .MuiDialog-paper": {
          backgroundColor: darkMode ? "#202940" : "#ffffff",
        }
      }}>
      <DialogTitle
        id="alert-dialog-title"
        sx={{ color: darkMode ? white.main : dark.main }}>
        {"¡Importante!"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: darkMode ? white.main : dark.main }}>
          ¿Está seguro de eliminar el nodo: <b>{infoDelete.name}</b>?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={closeDelete}>Cancelar</MDButton>
        <MDButton color="warning" onClick={submitDelete}>
          Eliminar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

NodeDelete.propTypes = {
  openDelete: PropTypes.bool,
  closeDelete: PropTypes.func,
  infoDelete: PropTypes.object,
  submitDelete: PropTypes.func,
};
